import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import wisata from "../../../Assets/Projects/website/Pesona.png";
import wisata5 from "../../../Assets/Projects/website/Pesona5.png";
import wisata2 from "../../../Assets/Projects/website/Pesona2.png";
import wisata3 from "../../../Assets/Projects/website/Pesona3.png";
import wisata4 from "../../../Assets/Projects/website/Pesona4.png";
import wisata6 from "../../../Assets/Projects/website/Pesona6.png";
import wisata7 from "../../../Assets/Projects/website/Pesona7.png";

function PesonaWisata() {
  return (
    <ProjectDetailCard
      title="Pesona Wisata North Sumatra"
      image={wisata}
      screenshots={[wisata2, wisata3, wisata4]}
      description="
      Pesona Wisata North Sumatra is a web-based tourism information system developed to promote the natural beauty, cultural heritage, and popular destinations across North Sumatra. The platform provides comprehensive information about tourist attractions, including destination details, locations, facilities, photo galleries, and travel recommendations. Designed with a modern and responsive interface, the website helps visitors easily explore tourism destinations while supporting digital promotion and increasing the visibility of local tourism across the region.
      "
      technologies={[
        "PHP",
        "CodeIgniter 4",
        "MySQL",
        "Bootstrap 5",
        "JavaScript",
        "HTML5",
        "CSS3",
        "Google Maps",
        "Responsive Design",
        "Git",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={wisata5} alt="gallery1" />
          <img src={wisata6} alt="gallery2" />
          <img src={wisata7} alt="gallery3" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default PesonaWisata;
